import angular from 'angular';

import SigninModal from '../modals/signin';

function Unauthorized($location, $rootScope, $q) {
  return {
    responseError: function (response) {
      switch (response.status) {
        case 408:
          $rootScope.authModal();
          break;
        case 403:
          if (!/signin/.test($location.path())) {
            if (!/^\/(fact|home)/.test($location.path())) {
              $location.search('redirect', $location.url());
            }
            $location.path('/signin');
          }
          break;
        case 401:
          if (!/signin/.test($location.path())) {
            if (!/^\/(fact|home)$/.test($location.path())) {
              $location.search('redirect', $location.url());
            }
            $location.path('/signin');
          }
          break;
      }
      return $q.reject(response);
    }
  };
}
Unauthorized.$inject = ['$location', '$rootScope', '$q'];
export default angular.module('interceptors.unauthorized', [SigninModal])
  .factory('Unauthorized', Unauthorized)
  .name;



// WEBPACK FOOTER //
// ./project/interceptors/unauthorized.js